module.exports = __webpack_public_path__ + "static/media/banking.40779d6c.png";